import React from "react";
import {withTheme} from "react-jss";

const ErrorBanner = (props) => {

  return (
    props.children && (
      <div
        style={{
          border: "1px solid " + (props.borderColor ? props.borderColor : props.theme.red), //ff0101
          borderRadius: "4px",
          background: props.backgroundColor ? props.backgroundColor : "white", //white
          color: props.color ? props.color : props.theme.red, //ff1818
          padding: "12px 12px",
          textAlign: "left",
          marginBottom: "14px",
        }}
      >
        {props.children}
      </div>
    )
  );
};

export default withTheme(ErrorBanner);
